import React from 'react';
import { TDescriptionsLayout, TDescriptionsVariant } from './descriptions.types';

export interface IDescriptionContext {
  variant: TDescriptionsVariant;
  layout: TDescriptionsLayout;
}

const initialContext: IDescriptionContext = { variant: 'on-light', layout: 'vertical' };

const descriptionContext = React.createContext<IDescriptionContext>(initialContext);

export const DescriptionContextProvider = descriptionContext.Provider;
export const DescriptionContextConsumer = descriptionContext.Consumer;
export const useDescriptionsContext = () => React.useContext(descriptionContext);
